import React from 'react';
import { Helmet } from 'react-helmet-async';
import BookHero from '../components/BookHero';
import BookNameGenerator from '../components/BookNameGenerator';
import BookFeatures from '../components/BookFeatures';
import BookHowItWorks from '../components/BookHowItWorks';
import BookTestimonials from '../components/BookTestimonials';
import BookGuide from '../components/BookGuide';
import BookSEOContent from '../components/BookSEOContent';
import BookFAQ from '../components/BookFAQ';
import BookCallToAction from '../components/BookCallToAction';

export default function BookPage() {
  return (
    <>
      <Helmet>
        <title>Book Title Generator | Create Captivating Book Names</title>
      </Helmet>
      <BookHero />
      <BookNameGenerator />
      <BookFeatures />
      <BookHowItWorks />
      <BookTestimonials />
      <BookGuide />
      <BookSEOContent />
      <BookFAQ />
      <BookCallToAction />
    </>
  );
}